import {
	Box,
	Button,
	Flex,
	Image,
	Spacer,
	Heading,
	Text,
	Badge,
	Link as ChakraLink,
} from '@chakra-ui/react'
import moment from 'moment'
import { Link } from 'react-router-dom'


const UserBusinessCard = ({ companyName, data }) => {
	const setBadgeColorScheme = (status) => {
		let colorScheme

		if (status === 'approved') {
			colorScheme = 'green'
		} else if (status === 'pending') {
			colorScheme = 'yellow'
		} else {
			colorScheme = 'red'
		}

		return colorScheme
	}

	return (
		<Box borderWidth={'1px'} borderColor={'gray.300'} p={2}>
			<Flex
				align="center"
				flexDirection={['column', 'column', 'row', 'row']}
				p={['3', '3', '0', '0']}
			>
				<Box mb={['2', '2', '0', '0']}>
					<Flex
						align="center"
						flexDirection={['column', 'column', 'row', 'row']}
						justify={['center', 'center', 'start', 'start']}
						textAlign={['center', 'center', 'start', 'start']}
					>
						<Image
							src={data?.logo}
							alt=""
							boxSize={'80px'}
							objectFit={'contain'}
							mr={['0', '0', '4', '4']}
							mb={['2', '2', '0', '0']}
						/>
						<Box>
						<ChakraLink href={`/business/${data?.id}`}>
							<Heading as="h3" fontSize="xl">
							{companyName}
							<Badge ms={2} colorScheme={setBadgeColorScheme(data?.status)}>
								{data?.status}
							</Badge>
							</Heading>
						</ChakraLink>
						<Text>Created on: {moment(data?.created_at).format('LL')}</Text>
						</Box>
					</Flex>
				</Box>
				<Spacer />
				<Box>
					<Button
						as={Link}
						to={`/business/${data?.id}`}
						size={'sm'}
						w={'100px'}
						variant={'brand'}
						ml={['0', '0', '2', '0']}
					>
						View
					</Button>
				
				</Box>
			</Flex>
		</Box>
	)
}

export default UserBusinessCard
